import { secretStorage } from "config"
import { setRolesInAxiosHeader } from "config/axiosConfig";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "store";
import { application } from "store/hooks";

const useSelectRole = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)
    const user_data = secretStorage.getItem("user")?.user_data
    const roleOptions = user_data?.map(({ id, role_id, role_label }) => ({
        id: role_id,
        name: role_label
    }));

    const setRoleIndex = application.useRoleIndex()

    const selectRole = useCallback((roleOption) => {
        const roleIndex = roleOptions.findIndex((role) => role.id === roleOption.id)
        if (roleIndex === -1) return
        setRoleIndex(roleIndex)
    }, [])

    const selectRoleInput = {
        options: roleOptions,
        placeholder: "תפקיד",
        input: {
            onChange: selectRole,
            value: roleOptions[roleIndex]
        },
        width: 80,
        minWidth: 80,
        light: true
    }

    return selectRoleInput
}

export default useSelectRole

